import { NavLink } from "react-router-dom";
import { Locale, useI18n } from "../../i18n";

type NavItem = {
  to: string;
  label: string;
};

type TopbarProps = {
  items: readonly NavItem[];
  languageLabel: string;
};

const locales: Locale[] = ["pt", "en"];

export function Topbar({ items, languageLabel }: TopbarProps) {
  const { locale, setLocale } = useI18n();

  return (
    <header className="topbar" aria-label="Navegação principal">
      <nav className="topbar-nav">
        {items.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) => `topbar-link${isActive ? " is-active" : ""}`}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="locale-switcher" aria-label={languageLabel}>
        {locales.map(item => (
          <button
            key={item}
            type="button"
            className={`locale-btn${locale === item ? " is-active" : ""}`}
            onClick={() => setLocale(item)}
          >
            {item.toUpperCase()}
          </button>
        ))}
      </div>
    </header>
  );
}
